import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'bootstrap';
import { lead_insert, getLeadConfig, getLeads, addUser } from "../../../api/lead";

const UserAdd = () => {
    const [configuration, setConfiguration] = useState(null);
    const toastRef = useRef(null);
    const [msg, setMsg] = useState("")
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    user_type: '',
    bucket: ''
  });

  const fetchConfig = async () => {
    const types = "buckets";
    const configRes = await getLeadConfig(types);
    if (configRes.status) {
      setConfiguration(configRes.data);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
        name, email, mobile, user_type, bucket
      } = formData;
  
      if (!name || !email || !mobile || !user_type || !bucket) {
        alert('Please fill in all fields before submitting.');
        return;
      }
      formData['bucket'] = parseInt(formData['bucket'])
      const response = await addUser(formData);
      if (response.status === true && toastRef.current) {
        setMsg(response.message)
        const toast = new Toast(toastRef.current);
        toast.show();
        setFormData({
            name: '',
            email: '',
            mobile: '',
            user_type: '',
            bucket: ''
        });
      }
  };

  return (
    <div className="container px-10 mb-5 mt-5">
      <div className="card shadow-sm">
        <div className="card-header">
          <h4 className="mb-0">Add New User</h4>
        </div>
        <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1065 }}>
        <div
          ref={toastRef}
          className="toast align-items-center text-bg-success border-0"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="d-flex">
            <div className="toast-body">{msg}</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              data-bs-dismiss="toast"
              aria-label="Close"
            ></button>
          </div>
        </div>
      </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold">User Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="User Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">E-mail</label>
              <input
                type="email"
                className="form-control"
                placeholder="E-mail ID"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Phone No.</label>
              <input
                type="tel"
                className="form-control"
                placeholder="Mobile Number"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">User Role</label>
                <select
                  className="form-select"
                  name="user_type"
                  value={formData.user_type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="Agent">Agent</option>
                  <option value="Manager">Manager</option>
                  <option value="Admin">Admin</option>
                </select>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Bucket</label>
                <select
                  className="form-select"
                  name="bucket"
                  value={formData.bucket}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  {configuration?.buckets?.map((bucket, index) => (
                    <option value={bucket?.id}>{bucket?.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <button type="submit" className="btn btn-primary primary-button w-100 rounded-pill mt-2">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserAdd;
